import { Component, effect, signal, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoggerService } from '../../logger.service';
import { DebounceTime } from '../../../directives/debounce-time';

const itemsList = [
  { name: 'Product A', category: 'Category 1' },
  { name: 'Product B', category: 'Category 2' },
  { name: 'Product C', category: 'Category 1' },
];

@Component({
  selector: 'casi-search-debounced',
  imports: [
    CommonModule,
    FormsModule,
    DebounceTime
  ],
  templateUrl: './search-debounced.html',
  styleUrl: './search-debounced.scss'
})
export class SearchDebounced {
  items = itemsList;

  readonly searchTerm = signal('');
  readonly $query = signal('');

  constructor(
    private logger: LoggerService
  ) {
    effect(() => {
      // this.logger.debug(`effect:`, this.debounceSearchValue());
      this.logger.debug(`effect:`, this.$query());
      // this.search(this.debounceSearchValue());
      this.search(this.$query());
    })
  }

  private search(value: string): void {
    this.logger.debug(`search: value: `, value, itemsList);
    if (!value) {
      this.items = itemsList;
    }

    const query = value.toLowerCase();
    this.items = itemsList.filter((item) => {
      return item.name.toLowerCase().includes(query) ||
        item.category.toLowerCase().includes(query)
    });
    this.logger.debug(`search:query:`, query, this.items);
  }
}
